import { styled } from "@pigment-css/react";
import { CalendarDays, ChevronGrabberVertical } from "@acto/web-common/components";
import { useTranslations } from "@acto/web-common/locales";
import { DatePicker } from "@acto/taskpane/field-sales-2/components/primitives/DatePicker";
import { Divider } from "@acto/taskpane/field-sales-2/components/primitives/Divider";
import { EditFieldCard, EditFieldPad, EditFieldRow, EditFieldRowLeft, EditFieldRowValue } from "./EditField";
import { Collapse } from "./Collapse";

// The due-date value row beneath the calendar grid.
const DueValueRow = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.fieldSalesTwo.spacing[16],
  paddingTop: theme.fieldSalesTwo.spacing[16],
}));

interface TodoDueDateFieldProps {
  /** Selected due date (UTC midnight), or null when the todo has no due date set. */
  value: Date | null;
  /** Formatted due-date label (or an empty-state placeholder) shown in the value/trigger rows. */
  label: string;
  /** When true the calendar is shown; otherwise a one-line trigger row. */
  open: boolean;
  /** Pick a date (closes the picker). */
  onChange: (date: Date) => void;
  /** Open the calendar (collapses the description). */
  onOpen: () => void;
}

/** Due-date section of the recap edit-todo screen: a calendar when open, a one-line row when closed. */
export function TodoDueDateField({ value, label, open, onChange, onOpen }: TodoDueDateFieldProps) {
  const t = useTranslations("fieldSalesTwo.recaps");

  return (
    <EditFieldCard>
      <Collapse open={open}>
        <EditFieldPad>
          <DatePicker value={value} onChange={onChange} />
          <Divider />
          <DueValueRow>
            <EditFieldRowLeft>
              <CalendarDays aria-hidden="true" />
              {t("edit.dueDate")}
            </EditFieldRowLeft>
            <EditFieldRowValue>{label}</EditFieldRowValue>
          </DueValueRow>
        </EditFieldPad>
      </Collapse>
      <Collapse open={!open}>
        <EditFieldRow type="button" onClick={onOpen}>
          <EditFieldRowLeft>
            <CalendarDays aria-hidden="true" />
            {t("edit.dueDate")}
          </EditFieldRowLeft>
          <EditFieldRowValue>
            {label}
            <ChevronGrabberVertical aria-hidden="true" />
          </EditFieldRowValue>
        </EditFieldRow>
      </Collapse>
    </EditFieldCard>
  );
}
